<template>
  <b-row class="justify-content-md-center">
       <img
     
        src="../../assets/logo.png"
        height="45px"
        @click="window.location.replace('https://www.smartpress.co')"
        style="position:absolute;left:30px;top:20px;margin-left:0px;cursor:pointer; "
      >
    <b-col cols="8">

      <h2>Securely signed Out, see you next time!</h2>
    </b-col>
  </b-row>
</template>


<script>
import router from "@/router"

export default {
  async created() {
    await this.$store.dispatch("auth/signOut")
    router.push("/signIn/contract")
    
  }
}
</script>

<style>
::-webkit-scrollbar {
    width: 0px;
    background: transparent; /* make scrollbar transparent */
}
</style>
